<template>
  <div>
    <b-card class="mt-4">
      <div v-show="!isLoaded">
        <Loading ref="loadingSpinner"></Loading>
      </div>
      <div v-if="isLoaded">
        <b-overlay :show="busy" rounded="sm">
          <div class="row pb-3">
            <div class="col">
              <h3>Młyny</h3>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-primary float-right"
                @click="AddMill"
              >
                <i class="fas fa-plus-circle fa-1x"></i> Dodaj Młyn
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-md-1 font-weight-bold">ID</div>
            <div class="col-md-8 font-weight-bold">Nazwa</div>
            <div class="col-md-3 font-weight-bold">Akcje</div>
          </div>
          <div class="row p-1" v-for="mill in mills" :key="mill.id">
            <div class="col-md-1">#{{ mill.id }}</div>
            <div class="col-md-8">
              <input
                type="text"
                :disabled="!mill.isEdit"
                class="form-control"
                v-model="mill.name"
              />
            </div>
            <div class="col-md-3 div-icons-area">
              <span @click="SaveData(mill)" v-if="mill.isEdit"
                ><i class="fas fa-check fa-lg color-green"></i
              ></span>
              <span @click="ChangeEditStatus(mill, false)" v-if="mill.isEdit">
                <i class="fas fa-times fa-lg color-red"></i>
              </span>
              <span
                v-if="!mill.isEdit"
                @click="ChangeEditStatus(mill, true)"
                v-b-tooltip.hover
                title="Zmień nazwę młynu"
              >
                <i class="fas fa-edit fa-lg"></i
              ></span>
              <span
                v-b-tooltip.hover
                title="Usuń młyn"
                v-if="!mill.isEdit"
                @click="RemoveMill(mill)"
              >
                <i class="fas fa-trash fa-lg"></i>
              </span>
            </div>
          </div>
        </b-overlay>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import urlConfig from "../../../mixins/url";
import toastr from "../../../mixins/toastr";
import Loading from "../../Common/Loading";

export default {
  name: "MillAdministration",
  components: { Loading },
  mixins: [urlConfig, toastr],
  mounted() {
    this.GetMills();
  },
  data() {
    return {
      busy: false,
      mills: [],
      isLoaded: false,
    };
  },
  methods: {
    GetMills() {
      var url = this.url.serverUrl + this.url.Mill.GetMills;
      var that = this;
      axios
        .get(url)
        .then(function (response) {
          response.data.forEach(function (entry) {
            entry.isEdit = false;
          });
          that.mills = response.data;
          that.isLoaded = true;
        })
        .catch(function (e) {
          var ref = that.$refs.loadingSpinner;
          ref.ShowErrorMessage(e);
          that.isLoaded = false;
        });
    },
    AddMill() {
      this.mills.unshift({ isEdit: true });
    },

    SaveData(item) {
      if (item.id) {
        this.UpdateMill(item);
      } else {
        this.SaveNewMill(item);
      }
    },

    SaveNewMill(item) {
      var url = this.url.serverUrl + this.url.Mill.AddMill;
      var that = this;
      this.busy = true;
      axios
        .post(url, { name: item.name })
        .then(function (response) {
          item.isEdit = false;
          item.id = response.data;
          that.DisplaySuccess(
            "Sukces!",
            "Nowy młyn '" + item.name + "' został dodany"
          );
          that.busy = false;
        })
        .catch(function (e) {
          that.busy = false;
          that.DisplayError("Błąd!", e);
          console.log(e);
        });
    },

    ChangeEditStatus(item, status) {
      if (status == true) {
        item.oldName = item.name;
      } else {
        item.name = item.oldName;
        item.oldName = undefined;
        if (!item.id) {
          this.url.Mills = this.url.Mills.filter((x) => x.id != undefined);
        }
      }

      item.isEdit = status;
    },
    UpdateMill(item) {
      var url = this.url.serverUrl + this.url.Mill.EditMill;
      var that = this;
      this.busy = true;
      axios
        .post(url, { name: item.name, id: item.id })
        .then(function (response) {
          item.isEdit = false;
          item.id = response.data;
          that.DisplaySuccess("Sukces!", "Nazwa została zmieniona");
          that.busy = false;
        })
        .catch(function (e) {
          that.busy = false;
          that.DisplayError("Błąd!", e);
          console.log(e);
        });
    },
    RemoveMill(item) {
      if (confirm("Czy napewno chcesz usunać młyn: " + item.name)) {
        var that = this;
        var url = this.url.serverUrl + this.url.Mill.RemoveMill;
        this.busy = true;
        axios
          .delete(url + "/" + item.id)
          .then(function () {
            that.mills = that.mills.filter((x) => x.id != item.id);
            that.busy = false;
          })
          .catch(function (e) {
            console.log(e);
            that.DisplayError("Błąd!", e);
            that.busy = false;
          });
      }
    },
  },
};
</script>